import { render, staticRenderFns } from "./all-tasks.vue?vue&type=template&id=37e2ada4&"
import script from "./all-tasks.vue?vue&type=script&lang=ts&"
export * from "./all-tasks.vue?vue&type=script&lang=ts&"
import style0 from "./all-tasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports